import { LoadableLazy } from '@confluence/loadable';

export const ApprovalsPane = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalsPane" */ '../src/ApprovalsPane/ApprovalsPane.tsx'
			)
		).ApprovalsPane,
});
